import { render, staticRenderFns } from "./LayoutSidebar.vue?vue&type=template&id=709a5a52&scoped=true"
import script from "./LayoutSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutSidebar.vue?vue&type=script&lang=js"
import style0 from "./LayoutSidebar.vue?vue&type=style&index=0&id=709a5a52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709a5a52",
  null
  
)

export default component.exports